<template>
  <q-page padding class="bg-grey-2">
    <UserSettings></UserSettings>
  </q-page>
</template>

<script setup lang="ts">
import UserSettings from 'components/UserSettings.vue'
</script>
